import React, { Component } from "react"
import Slider from "react-slick"

import CarouselItem from "./CarouselItem/MainCarouselItem"

import "./slick.scss"
import "./carousel.scss"

export default class SimpleSlider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSlide: 0,
      activeSlide2: 0,
    }
  }
  render() {
    const settings = {
      dots: false,
      arrows: true,
      lazyload: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 7000,
      draggable: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
      afterChange: (current) => this.setState({ activeSlide2: current }),
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            arrows: false,
            infinite: true,
          },
        },
      ],
    }

    return (
      <Slider {...settings} className="mainCarousel" tabIndex={-1}>
        {this.props.items.arr_header_videos.map((item, index) => {
          return this.props.items_videos.data.map((item_video) => {
            if (
              item_video.description && item_video.description.includes(item.value.text_video_description)
            ) {
              return (
                <CarouselItem
                  key={index}
                  item={item}
                  item_video={item_video.assets.hls}
                  activeSlide={this.state.activeSlide}
                  activeSlide2={this.state.activeSlide2}
                  text={index}
                  background_picture={item.value.asset_carousel_item_picture}
                  background_picture_jpg={item.value.asset_carousel_item_picture_jpg}
                  background_picture_mobile={item.value.asset_carousel_item_mobile_picture}
                />
              )
            }
          })
        })}
      </Slider>
    )
  }
}
